// src/components/DemoLaasSetup.js
import { useMemo ,useEffect } from 'react';
import { OnboardingLayout } from './OnboardingLayout';
import { getRandomMessage } from '../utils/getSplashMessage';
import './SplashScreen.css'; 

export function DemoLaasSetup({
  organoidOptions,
  protocolOptions,
  //selectedOrganoid,
  selectedProtocol,
  //setSelectedOrganoid,
  setSelectedProtocol,
  setDrugTimestamp,
  isRecording,
  setUiState, 
  theme,
  splashLines,
  ui_state
}) {

    const confirmSelection = () => {
        {/* if (!selectedOrganoid || !selectedProtocol) return; */}
        if (!selectedProtocol) return;
        setUiState('setup');
    };

    const splashMessage = useMemo(() => getRandomMessage(theme), [theme]); // [theme] is dependency - only rerun function if theme changes 

    useEffect(() => {
        // Splash is always visible on this screen
        if (splashMessage?.id) {
            // Persist locally
            localStorage.setItem("splash_message_id", splashMessage.id);

            // Send to backend securely
            fetch(`${process.env.REACT_APP_API_URL}/api/session/update`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("authToken")}`
            },
            body: JSON.stringify({
                session_id: localStorage.getItem("session_id"),
                splash_message_id: splashMessage.id
            })
            });
        }
    }, [splashMessage]);


    useEffect(() => {
        if (!splashMessage?.id) return;

        const sessionId = localStorage.getItem("session_id");
        const token = localStorage.getItem("authToken");

        if (!sessionId || !token) return;

        fetch(`${process.env.REACT_APP_API_URL}/api/session/message_exposure`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                session_id: sessionId,
                message_id: splashMessage.id,
                theme,
                ui_state
            })
        });
    }, [splashMessage]);


    return (
        <OnboardingLayout 
            splashMessage={splashMessage.text} 
            splashMessageId={splashMessage.id} 
            splashLines={splashLines}
        >
            <p className="controls-log">Available Brain-on-a-Chip identified.<br />
                Select protocol to begin.</p>

            <div className="controls-select-group">

            {/* 
                <select 
                    onChange={(e) => {
                    console.log("Selected organoid:", e.target.value);
                    setSelectedOrganoid(e.target.value);
                        }}
                    disabled={isRecording}
                >
                    <option value="">Select organoid</option>
                    {organoidOptions.map((org) => (
                        <option key={org.id} value={org.id}>{org.id}</option>
                    ))}
                </select>
            */}

                <select 
                    onChange={(e) => setSelectedProtocol(e.target.value)}
                    disabled={isRecording}
                    value={selectedProtocol}
                >
                    <option value="">Select protocol</option>
                    {protocolOptions.map((proto) => (
                        <option key={proto.name} value={proto.name}>{proto.name}</option>
                    ))}
                </select>
            </div>

            <button
                //disabled={!selectedOrganoid || !selectedProtocol}
                disabled={!selectedProtocol}
                onClick={confirmSelection} 
                className="controls-start-button"
            >
                Confirm Selection
            </button>
        </OnboardingLayout>
    );
}
